import Modal from "./Modal";
export { ModalContent as Content, ModalButtons as Buttons } from "./style";
export { default as Header } from "./Header";
export default Modal;